import type { RequestParams } from '@/shared/api';
import type { ProductItemListParams } from '../model/types';

export const PRODUCT_KEYS = {
  all: ['product'] as const,
  list: (params?: RequestParams) => [...PRODUCT_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...PRODUCT_KEYS.all, 'detail', id] as const,
  itemList: (params?: ProductItemListParams) => [...PRODUCT_KEYS.all, 'item-list', params] as const,
};
